module.exports = __webpack_public_path__ + "img/keyboard-keys-new.13bf0a39.png";